import { Tag } from "../../../models/Tag";

export const mockChannel = (tag: string): Tag => ({
    displayName: tag,
    tag,
    tagType: null,
    icon: null,
    id: -1,
})